// @flow
import React from 'react';
import { RouteUtil } from 'utils/RouteUtil';
import { withRouter } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
// eslint-disable-next-line
import styles from "./styles.scss";

type Offering = {
  title: string,
  link: string,
};

type Props = {
  links: Array<Offering>,
  onPress: () => void,
};

const Offerings = (props: Props) => {
  const { links, onPress } = props;

  const handleClick = (link, title) => {
    if (title === 'Loyalty Program') {
      window.open(
        'https://totalenvironmentloyaltyprogram.mloyalretail.com/microsite/'
      );
      onPress();
    } else {
      RouteUtil.setRouteChange(props, link);
      onPress();
    }
  };

  return (
    <ul className={'offerings-container'}>
      {links.map((offering, idx) => (
        <li
          key={idx}
          onClick={() => handleClick(offering.link, offering.title)}
        >
          {offering && offering.title === 'Machine Craft' ? (
            <HashLink
              className={'offering h3-font bold'}
              to="/homes#machine-craft"
            >
              {offering.title}
            </HashLink>
          ) : offering.title === 'eDesign' ? (
            <HashLink className={'offering h3-font bold'} to="/homes#eDesign">
              {offering.title}
            </HashLink>
          ) : (
            <a className={'offering h3-font bold'}>{offering.title}</a>
          )}
        </li>
      ))}
    </ul>
  );
};

export default withRouter(Offerings);
